export const SET_DEAL_BREAKERS = "setDealBreakers";

export const setDealBreakers = (payload: any) => {
  return {
    type: SET_DEAL_BREAKERS,
    payload,
  };
};
